import { render, staticRenderFns } from "./RegulationModal.vue?vue&type=template&id=3e7d651a&scoped=true"
import script from "./RegulationModal.vue?vue&type=script&lang=js"
export * from "./RegulationModal.vue?vue&type=script&lang=js"
import style0 from "./RegulationModal.vue?vue&type=style&index=0&id=3e7d651a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7d651a",
  null
  
)

export default component.exports